//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientGraphQLAuthMutation, clientQuery } from 'Core/data/GraphQLApi';
import { clientPOST } from 'Core/data/RestApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    LOGIN_REQUEST,
    LOGIN_FORGOT_PASSWORD_REQUEST,
    LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST,
    LOGIN_CHANGE_PASSWORD_REQUEST,
    LOGIN_CHECK_LOGIN_USER_BY_CODE,
    LOGIN_LOGOUT_REQUEST,
} from 'Redux/actionTypes';

//Actions
import {
    loginResult,
    loginForgotPasswordResult,
    loginConfirmForgotPasswordResult,
    forceChangePasswordResult,
    loginOpenModalChangePassword,
    authGetAuthenticationDetailsResult,
    logoutResult
} from 'Redux/actions';

function* loginRequest({ payload }) {
    try {
        const { username, password, history } = payload;
        let data = yield call(
            clientGraphQLAuthMutation,
            `
                mutation ($username: String!, $password: String!){
                    result: signIn(username:$username, password:$password){
                        authenticationResult{
                            AccessToken
                            ExpiresIn
                            IdToken
                            RefreshToken
                            ChallengeName
                            Session
                        },
                        emailVerified
                        userId
                        username
                        fullname
                        isRestricted
                        dealerIds
                    }
                }
            `,
            {
                username,
                password
            }
        );

        if (data && data.result && data.result.authenticationResult) {
            let { emailVerified, authenticationResult } = data.result;
            if (!emailVerified) {
                yield put(loginResult(authenticationResult, true));
                return
            } else {
                if (authenticationResult?.ChallengeName === "NEW_PASSWORD_REQUIRED") {
                    yield put(loginOpenModalChangePassword({
                        session: authenticationResult.Session,
                        username: data.result.username,
                        open: true,
                    }))
                } else {
                    localStorage.setItem("AccessToken", authenticationResult.AccessToken);
                    localStorage.setItem("RefreshToken", authenticationResult.RefreshToken);
                    localStorage.setItem("IdToken", authenticationResult.IdToken);
                    localStorage.setItem("username", data.result.username);
                    authenticationResult.username = data.result.username
                    yield put(loginResult(authenticationResult, false));

                    // if (data?.result?.username === "aivideoreview") {
                    //     history('/app/accounts/videoreview')
                    // } else {
                    history('/app')
                    // }

                }
            }

        } else {
            if (data.errorMessage || data?.errors[0]?.message) {
                throw Error(data.errorMessage || data?.errors[0]?.message);
            } else {
                throw Error("Incorrect Username or Password");
            }
        }
    } catch (exc) {
        ExceptionManager(exc, 'Core/views/login/redux', 'loginRequest')
        yield put(loginResult(null, false, exc));
    }
}

function* loginForgotPassword({ payload }) {
    try {

        let QUERY = `
            mutation forgotPassword ($username: String!) {
                result: forgotPassword (username: $username) { username }
            }
        `;

        let data = yield call(
            clientGraphQLAuthMutation,
            QUERY,
            payload
        );

        if (data.result) {
            yield put(loginForgotPasswordResult({ result: true }));
        }
    } catch (exc) {
        let regex = /LimitExceededException/;
        let error = "forgot_password_verify_user"
        if (regex.test(exc)) {
            error = "forgot_password_limit"
        }
        yield put(loginForgotPasswordResult({ error: error }));
        ExceptionManager(exc, 'Core/views/login/redux', 'loginForgotPassword')
    }
}

function* loginConfirmForgotPassword({ payload }) {
    try {

        let QUERY = `
            mutation confirmForgotPassword (
                $confirmationCode: String!,
                $username: String!,
                $password: String!
            ) {
                result: confirmForgotPassword (
                    confirmationCode: $confirmationCode,
                    username: $username,
                    password: $password
                )
            }
        `

        let data = yield call(
            clientGraphQLAuthMutation,
            QUERY,
            payload
        );

        if (data.result) {
            yield put(loginConfirmForgotPasswordResult({ result: data.result }))
        }

    } catch (exc) {
        yield put(loginConfirmForgotPasswordResult({ error: exc }))
    }
}

function* checkLoginUserByCode({ payload }) {
    const domainUri = window.location.hostname === "localhost" ? `http://localhost:3000` : `https://${window.location.hostname}`;
    const { code, history } = payload;
    try {
        let headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
        };

        let data = yield call(
            clientPOST,
            '',
            {
                code,
                client_id: `${endpoints.COGNITO_CLIENT_ID}`,
                grant_type: 'authorization_code',
                redirect_uri: `${domainUri}/login-social-media`
            },
            `${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}oauth2/token`,
            headers,
            true
        );
        if (data) {
            localStorage.setItem("AccessToken", data.access_token);
            localStorage.setItem("RefreshToken", data.refresh_token);
            localStorage.setItem("IdToken", data.id_token);
            history('/app/accounts/list')
        }
    } catch (exc) {
        // catch throw
        ExceptionManager(exc, 'Core/views/login/redux', 'Error Login with social media');
        localStorage.removeItem('AccessToken');
        localStorage.removeItem('RefreshToken');
        localStorage.removeItem('IdToken');
        localStorage.removeItem('username');
        const domainUri = window.location.hostname === "localhost" ? `http://localhost:3000` : `https://${window.location.hostname}`;
        window.location = `${endpoints.COGNITO_DOMAIN_USER_POOL_EXTERNAL}logout?client_id=${endpoints.COGNITO_CLIENT_ID}&logout_uri=${domainUri}/login`
    }
}

function* forceChangePassword({ payload }) {
    try {
        const { values } = payload;
        let QUERY = `
            mutation forceChangePassword ($session: String!, $username: String!, $newPassword: String!) {
                result: forceChangePassword (session: $session, username: $username, newPassword: $newPassword) {
                    authenticationResult {
                        AccessToken
                        ExpiresIn
                        RefreshToken
                        IdToken
                        ChallengeName
                        Session
                    }
                    emailVerified
                    userId
                    username
                    fullname
                }
            }
        `;

        let data = yield call(
            clientGraphQLAuthMutation,
            QUERY,
            values,
        );

        if (data && data.result && data.result.authenticationResult) {
            let { emailVerified, authenticationResult } = data.result;
            if (!emailVerified) {
                yield put(loginResult(authenticationResult, true));
                return
            } else {
                yield put(forceChangePasswordResult({ id: data.result.userId }))
            }
        }
    } catch (exc) {
        ExceptionManager(exc, 'Core/views/login/redux', 'forceChangePassword')
        yield put(forceChangePasswordResult({ error: true }))
    }
}

function* logoutRequest({ payload }) {
    try {
        const idToken = localStorage.getItem("IdToken");
        const refreshToken = localStorage.getItem("RefreshToken");

        let data = yield call(
            clientGraphQLAuthMutation,
            `
                mutation ($refreshToken: String! $idToken: String!){
                    result: logoutSession(refreshToken: $refreshToken, idToken: $idToken){
                        success
                        message
                    }
                }
            `,
            {
                idToken,
                refreshToken
            }
        );
        if (data && data.result) {
            yield put(logoutResult(data.result));
        } else {
            if (data.errorMessage || data?.errors[0]?.message) {
                throw Error(data.errorMessage || data?.errors[0]?.message);
            } else {
                throw Error("Error during logout");
            }
        }
    } catch (exc) {
        ExceptionManager(exc, 'Core/views/login/redux', 'logoutRequest');
    }
}

function* watchLoginRequests() {
    yield takeEvery(LOGIN_REQUEST, loginRequest);
    yield takeEvery(LOGIN_FORGOT_PASSWORD_REQUEST, loginForgotPassword);
    yield takeEvery(LOGIN_CONFIRM_FORGOT_PASSWORD_REQUEST, loginConfirmForgotPassword);
    yield takeEvery(LOGIN_CHECK_LOGIN_USER_BY_CODE, checkLoginUserByCode);
    yield takeEvery(LOGIN_CHANGE_PASSWORD_REQUEST, forceChangePassword);
    yield takeEvery(LOGIN_LOGOUT_REQUEST, logoutRequest);
}

//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchLoginRequests)
    ]);
}